<!--
 * @LastEditors: zhanglinju
-->
<template>
  <div class="home">
    <div

      class="tabview"
    >
      <van-tabs
        v-model="activeTab"
        swipeable
        title-active-color="#222"
        color="gold"
        line-width="80px"
        line-hight="2px"
        @click="checktab"
      >
        <van-tab
          v-for="(item, index) in list"
          :key="index"
          :title="item.name"
        >
          <!-- 产品推荐模块 -->
          <div
            id="activeTabs"
            ref="tabs"
            class="list"
            :class="routerName == 'mobile' ? 'list2' : ''"
          >
            <div
              v-for="(items, indexs) in cataloglist"
              :key="indexs"
              class="lineView"
              @click="openDetails(items)"
            >
              <div
                v-show="items.contentCornerMarker"
                :class="[routerName == 'mobile'?'imgTitle2box':'imgTitlebox']"
              >
                <img
                  class="imgTitle2"
                  :src="items.contentCornerMarker"
                  alt=""
                >
              </div>
              <div
                :class="
                  items.styleId == 1 ? 'lineView_leftImg' : 'lineView_leftImg2'
                "
              >
                <!-- <img class="imgTitle" src="../assets/hight.png" alt="" /> -->
                <div
                  :class="[
                    items.contentCornerMarker ? 'addBtm' : '',
                    items.styleId == 1 ? 'imgItembox' : 'imgItembox2'
                  ]"
                >
                  <img
                    class="imgItem"
                    :src="items.image"
                    alt=""
                  >
                </div>
              </div>
              <div
                :class="
                  items.styleId == 1
                    ? 'lineView_rightTitle'
                    : 'lineView_rightTitle2'
                "
              >
                <div :class="items.styleId == 1 ? 'item_name' : 'item_name2'">
                  {{ items.title }}
                </div>
                <span
                  :class="
                    items.styleId == 1
                      ? 'item_advertising'
                      : 'item_advertising2'
                  "
                >{{ items.subtitle }}</span>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Hometab',
    props: {
        list: {
            default: null,
            type: Array,
        },
        cataloglist: {
            default: null,
            type: Array,
        },
        siteId: {
            default: null,
            type: String,
        },
    },
    data () {
        return {
            activeTab: 0,
            routerName: null,
        };
    },
    watch: {
        activeTab (e) {
            this.activeTab = e;
            if (this.list) {
                this.$emit('catalogDetail', this.list[e].catalogId, e);
            }
        },
    },
    mounted () {
        this.routerName = this.$route.name;
        // let top = sessionStorage.getItem('sroTop');
        // console.log(top);
        // if (top !== null && top !== undefined) {
        //     this.$nextTick(() => {
        //         this.$refs.tabs[this.activeTab].scrollTop = top;
        //     });
        // }
    },
    methods: {
        checktab (index) {
            this.activeTab = index;
            // this.$emit('catalogDetail', this.list[index].catalogId, index);
        },
        setScrollTop () {
            let top = sessionStorage.getItem('sroTop');
            console.log(top);
            if (top !== null && top !== undefined) {
                this.$nextTick(() => {
                    this.$refs.tabs[this.activeTab].scrollTop = top;
                });
            }
        },
        openDetails (item) {
            sessionStorage.removeItem('iframeUrl');
            // console.log(this.$refs);
            sessionStorage.setItem('sroTop', this.$refs.tabs[this.activeTab].scrollTop);
            // console.log(this.routerName);
            if (this.routerName === 'mobileModules') {
                // sessionStorage.setItem('contentIndex', item);
                this.$router.push({
                    name: 'mobileBoxContent',
                    query: { contentId: item.contentId },
                });
            } else if (this.routerName === 'mobile') {
                // sessionStorage.setItem('contentIndex', item);
                this.$router.push({
                    name: 'mobileContent',
                    query: { contentId: item.contentId },
                });
            }
        },
    },
    // 记录离开时的位置
    beforeRouteLeave (to, from, next) {
        // 保存滚动条元素div的scrollTop值
        console.log('lk');
        // this.scrollY = document.querySelector('.list').scrollTop;
        // console.log(this.scrollY)
        next();
    },
    // 为div元素重新设置保存的scrollTop值
    beforeRouteEnter (to, from, next) {
        next(vm => { // vm = this
            console.log('jr');
            // document.querySelector('.container').scrollTop = vm.scrollY;
            // console.log( document.querySelector('.container').scrollTop )
        });
    },
};
</script>
<style>
img[src=""],
img:not([src]) {
  opacity: 0;
}
.van-tab {
  font-size: 18px !important;
}
</style>
<style lang="scss" scoped>
.home {
  background: linear-gradient(white, #ededed);
  // min-height: 100vh;
}
.tabview {
  width: 100%;
  // display: flex;
  // justify-content: space-around;
  // align-items: center;
  // padding: 15px 0 5px 0;
  // position: fixed;
  top: 180px;
  // z-index: 1000;
  background: white;
  .tabItem {
    font-size: 18px;
    // font-weight: bold;
    color: #c6c5c5;
  }
  .activeItem {
    font-size: 20px;
    // font-weight: bold;
    color: #222222;
  }
}
.imgTitle {
  position: relative;
  left: -42px;
  top: -5px;
  width: 50px;
  height: 20px;
}

.imgTitle3 {
  position: relative;
  left: -42px;
  top: -5px;
  width: 50px;
  height: 20px;
}
.list {
  width: 100%;
  z-index: 0;
  height:calc(100vh - 271px);
  padding-bottom: 20px;
  overflow-x: hidden;
  overflow-y: scroll;
  text-align: center;
  background: linear-gradient(white, #ededed);
}
.list2 {
  width: 100%;
  z-index: 0;
  height: calc(100vh - 44px);
  padding-bottom: env(safe-area-inset-bottom);
  // padding-bottom: 20px;
  overflow-x: hidden;
  overflow-y: scroll;
  text-align: center;
  background: linear-gradient(white, #ededed);
}
.list::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.lineView {
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: white;
  height: 112px;
  margin: 10px 10px 0 10px;
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 7px;
  position: relative;
  .lineView_leftImg {
    position: relative;
    width: 75px;
    height: 90px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
    .imgItem {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .lineView_leftImg2 {
    position: relative;
    width: 140px;
    height: 90px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // margin-left: 20px;
    .imgItem {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .lineView_rightTitle2 {
    display: flex;
    flex-direction: column;
    margin-left: -5px;
    width: 150px;
    .item_name2 {
      font-size: 15px;
      font-weight: bold;
      margin-bottom: 10px;
      // width: 150px;
      text-overflow: ellipsis; /*让截断的文字显示为点点。还有一个值是clip意截断不显示点点*/
      white-space: nowrap; /*让文字不换行*/
      overflow: hidden; /*超出要隐藏*/
    }
    .item_advertising2 {
      font-size: 12px;
      color: #bbbaba;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      height: 32px;
    }
  }

  .lineView_rightTitle {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    width: 150px;
    // padding-top: 20px;
    // align-items: center;
    // justify-content: center;
    .item_name {
      font-size: 15px;
      font-weight: 700;
      overflow: hidden;
      text-align: left;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      height: 37px;
      word-wrap: break-word;
      white-space: normal;
      word-break: break-all;
    }

    .item_advertising {
      font-size: 12px;
      color: #bbbaba;
      overflow: hidden;
      text-align: left;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      height: 32px;
    }
  }
}
@media screen and (max-width: 350px) {
  .lineView_rightTitle {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    width: 120px !important;
  }
  .lineView_rightTitle2 {
    width: 120px !important;
  }
}
@media screen and (min-width: 400px) {
  .lineView_rightTitle {
    display: flex;
    flex-direction: column;
    width: 180px !important;
    margin-left: 30px !important;
  }
}
.imgItembox {
  width: 120px;
  height: 90px;
  min-height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
}
.imgItembox2 {
  width: 110px;
  height: 110px;
  min-height: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.imgTitle2box {
  position: absolute;
  left: 4px;
  top: 2px;
  width: 40px;
  height: 20px;
  justify-content: start;
  display: flex;
  align-items: center;
  img {
    height: 20px;
    width: auto;
    z-index: 999;
  }
}
.imgTitlebox {
  position: absolute;
  left: 4px;
  top: 2px;
  width: 40px;
  height: 20px;
  justify-content: start;
  display: flex;
  align-items: center;
  img {
    height: 20px;
    width: auto;
    z-index: 999;
  }
}
// .addleft{
//   position: absolute;
//   left: -20px;
// }
// .addleft2{
//   position: absolute;
//   left: -25px;
// }
.activeItemBtn {
  border-bottom: 2px gold solid;
  padding-bottom: 5px;
}
.addBtm {
  position: relative;
  bottom: 5px;
}
.swipe-list {
  z-index: 0;
}
</style>
